import { playSound } from 'utils/play-sound';
import notificationSound from 'assets/sounds/notification-sound.mp3';

export const playNotificationSound = () => {
  playSound(notificationSound);
};
